const CART_KEY = 'urban_menswear_cart'

function readCart() {
  try {
    return JSON.parse(localStorage.getItem(CART_KEY)) || []
  } catch (error) {
    return []
  }
}

function writeCart(items) {
  localStorage.setItem(CART_KEY, JSON.stringify(items))
  window.dispatchEvent(new CustomEvent('cart-change'))
}

export function getCart() {
  return readCart()
}

export function getCartCount() {
  return readCart().reduce((sum, item) => sum + item.quantity, 0)
}

export function addToCart(product, options = {}) {
  const size = options.size || product.sizes[0]
  const quantity = options.quantity || 1
  const items = readCart()
  const existing = items.find(item => item.id === product.id && item.size === size)

  if (existing) {
    existing.quantity += quantity
  } else {
    items.push({
      id: product.id,
      name: product.name,
      price: product.price,
      image: product.image,
      color: product.color,
      size,
      quantity
    })
  }

  writeCart(items)
}

export function updateCartItem(id, size, quantity) {
  const next = readCart()
    .map(item => item.id === id && item.size === size ? { ...item, quantity } : item)
    .filter(item => item.quantity > 0)

  writeCart(next)
}

export function removeCartItem(id, size) {
  writeCart(readCart().filter(item => !(item.id === id && item.size === size)))
}

export function clearCart() {
  writeCart([])
}
